const meta = {
  requiresAdmin: false,
  requiresAuth: true
}

export const routes = [
  {
    path: '/diagnostico/:id',
    component: () => import(/* webpackChunkName: "diagnostic" */ './components/Diagnostic'),
    meta,
    name: 'diagnostic',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/diagnostico/:id/tema',
    component: () => import(/* webpackChunkName: "diagnostic" */ './components/DiagnosticAnswer'),
    meta,
    name: 'diagnostic.answer',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/diagnostico/:id/tema/:idtema',
    component: () => import(/* webpackChunkName: "diagnostic" */ './components/DiagnosticAnswerQuestion'),
    meta,
    name: 'diagnostic.answer.question',
    meta: {
      requiresAuth: true
    }
  }
]
